// Reusable brand logo — sourced from company-provided PNG
// The uploaded lockup contains: colorful butterfly (top ~65%) + "METAMORPHOSIS" text (bottom).
// We render the butterfly image (cropped) alongside custom-styled text so it works on our dark theme.

const LOGO_URL = "https://customer-assets-cm19k8pv.emergentagent.net/job_metamorph-pro/artifacts/4u50yii3_Mit%20New%20Logo%20-%2024.png";

// Show only the top part of the PNG (the butterfly) — clips off the black wordmark
const butterflyStyle = {
  objectFit: "cover",
  objectPosition: "center 22%",
};

export function Butterfly({ size = 36, className = "" }) {
  // Show only the butterfly (top ~68% of the source PNG) by using background-image with position/size
  return (
    <span
      role="img"
      aria-label="Metamorphosis"
      className={className}
      style={{
        display: "inline-block",
        width: `${size}px`,
        height: `${size}px`,
        flexShrink: 0,
        backgroundImage: `url(${LOGO_URL})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center top",
        backgroundSize: `${size}px ${size * 1.5}px`,
        filter: "drop-shadow(0 0 10px rgba(106,13,173,0.4))",
      }}
    />
  );
}

export function Lockup({ size = 44, className = "", stacked = false }) {
  return (
    <div className={`flex ${stacked ? "flex-col items-center gap-2" : "items-center gap-3"} ${className}`}>
      <Butterfly size={size} />
      <div className={stacked ? "text-center" : ""}>
        <div
          className="font-display text-[#0A0A14] leading-none tracking-tight"
          style={{ fontSize: size * 0.48 }}
        >
          Metamorphosis
        </div>
        <div className="text-[9px] tracking-[0.32em] text-[#A4801C]/90 mt-1 uppercase">
          Institute of Transformation
        </div>
      </div>
    </div>
  );
}

// Full logo image (for splash / print-style contexts). Includes the black text — only usable on light bg.
export function FullLogo({ className = "" }) {
  return <img src={LOGO_URL} alt="Metamorphosis" className={className} />;
}

export const LOGO_ASSET_URL = LOGO_URL;
